import { lowerLanguage } from "src/i18n";
import {
  agency_product_t,
  contractor_info_t,
  contractor_t,
  structure_t,
} from "src/types";
import { FormikMainInsured } from "src/types/formik";
import { Asset, GetGroupExtraInfo, MainInsuredGroup } from "src/types/formik/group.types";
import { quote_t } from "src/types/http/quote.types";
import { generateFiscalCode, get_language } from "src/utils";

const get_period = (insured_days: string, insured_daily: string) => {
  if (insured_days === "daily") {
    if (insured_daily)
      return "3";
    return "1";
  };
  if (insured_days === "weekly_7") return "4";
  if (insured_days === "monthly_30") return "5";
  if (insured_days === "quarterly_90") return "6";
};

const get_contractor_group = (values?: MainInsuredGroup): contractor_t => {
  const contractor_: contractor_t = {
    isInsured: values?.isInsured === 'id_yes',
    name: values?.name?.trim(),
    surname: values?.surname?.trim(),
    nationality: values?.nationality === "foreign_id" ? "EXT" : "IT",
    ...(values?.cap && values?.nationality === "IT" && {
      cap: values?.cap,
    }),
    ...(values?.vatNumber && {
      vatNumber: values?.vatNumber,
    }),
    fiscalCode:
      values?.fiscalCodeQuestion === "yes_id"
        ? values?.fiscalCode?.toUpperCase()
        : generateFiscalCode({
          name: values?.name || "",
          surname: values?.surname || "",
          birthDate: values?.birthDate || "",
          birthPlace: values?.birthPlace || "",
          gender: values?.gender === "M" ? "M" : "F",
        }),
    ...(values?.birthDate &&
      values?.fiscalCodeQuestion === "no_id" && {
      birthDate: values?.birthDate.split("/").reverse().join("-"),
    }),
    ...(values?.birthNation &&
      values?.fiscalCodeQuestion === "no_id" && {
      birthNation: values?.birthNation,
    }),
    ...(values?.birthPlace &&
      values?.fiscalCodeQuestion === "no_id" && {
      birthPlace: values?.birthPlace,
    }),
    ...(values?.gender &&
      values?.fiscalCodeQuestion === "no_id" && {
      gender: values?.gender === "M" ? "M" : "F",
    }),
    contractor: true,
    mainContact: {
      type: "email",
      value: values?.email?.trim(),
    },
    ...(values?.phone?.formattedPhone && {
      otherContacts: [{ type: "mobile", value: values?.phone?.formattedPhone }],
    }),
    tdConsent: values?.consentTd,
    privacyConsent: values?.consentPrivacy,
    ...(values?.consentMarketing && {
      marketingConsent: values?.consentMarketing,
    }),
    ...(values?.consentProfiling && {
      profilingConsent: values?.consentProfiling,
    }),
    ...(values?.consentCommunication && {
      communicationConsent: values?.consentCommunication,
    }),
  };
  return contractor_;
};

const get_assets_group = (
  contractors?: Asset[]
): contractor_info_t[] => {
  const assets_: contractor_info_t[] = [];
  contractors?.map((contractor) =>
    assets_.push({
      name: contractor?.name?.trim(),
      surname: contractor?.surname?.trim(),
      nationality: contractor?.nationality === "foreign_id" ? "EXT" : "IT",
      fiscalCode:
        contractor?.fiscalCodeQuestion === "yes_id"
          ? contractor?.fiscalCode?.toUpperCase()
          : generateFiscalCode({
            name: contractor?.name || "",
            surname: contractor?.surname || "",
            birthDate: contractor?.birthDate || "",
            birthPlace: contractor?.birthPlace || "",
            gender: contractor?.gender === "M" ? "M" : "F",
          }),
      ...(contractor?.birthDate &&
        contractor?.fiscalCodeQuestion === "no_id" && {
        birthDate: contractor?.birthDate.split("/").reverse().join("-"),
      }),
      ...(contractor?.birthNation &&
        contractor?.fiscalCodeQuestion === "no_id" && {
        birthNation: contractor?.birthNation,
      }),
      ...(contractor?.birthPlace &&
        contractor?.fiscalCodeQuestion === "no_id" && {
        birthPlace: contractor?.birthPlace,
      }),
      ...(contractor?.gender &&
        contractor?.fiscalCodeQuestion === "no_id" && {
        gender: contractor?.gender === "M" ? "M" : "F",
      }),
    })
  );

  return assets_;
};

const get_structure = (
  convention_id: string,
  structures: structure_t[]
): string => {
  let structure = "";
  structure =
    structures?.find((item) => item?.id === convention_id)?.name?.[
    get_language().toLowerCase()
    ] || "";

  return structure;
};

export const get_quote_group_data = (
  group: GetGroupExtraInfo,
  mainInsured: MainInsuredGroup,
  formikMainInsured: FormikMainInsured,
  agency?: agency_product_t,
  quoteId?: string
): quote_t => {
  const agencyWithStructure = {
    id: agency?.id,
    name: agency?.name,
    ...(formikMainInsured?.convention && {
      structure: formikMainInsured?.convention,
    }),
    ...(formikMainInsured?.convention && {
      structureName: get_structure(
        formikMainInsured?.convention,
        agency?.structures || []
      ),
    }),
    isCustomActive: agency?.isCustomActive || false,
    isOriginalPayment:
      agency?.isOriginalPayment === undefined
        ? true
        : agency?.isOriginalPayment,
    isCustomPaymentLabel:
      agency?.isCustomPaymentLabel === undefined
        ? false
        : agency?.isCustomPaymentLabel,
  }

  const data_: quote_t = {
    agency: agencyWithStructure,
    period: {
      type: get_period(formikMainInsured?.insured_days, formikMainInsured?.insured_daily),
      from: formikMainInsured?.coverage_start_date?.split("/").reverse().join("-"),
      to: formikMainInsured?.coverage_end_date?.split("/").reverse().join("-"),
    },
    quoteId,
    contractor: get_contractor_group(mainInsured),
    assets: get_assets_group(group),
    sections: [],
    language: lowerLanguage,
    coverage: formikMainInsured.coverage_type_radios,
    discount: mainInsured.discount?.toUpperCase(),
    isGroup: true,
    token: 'token',
  }

  return data_;
}